import { useCallback, useEffect, useRef } from 'react';

/**
 * useIsMounted
 * Checks of the component has been unmounted in the vDOM
 *
 * use for long running aync tasks that performs state updates
 *
 * e.g.
 *
 * const isMounted = useIsMounted()
 *
 * if(isMounted){
 *      setState('you can set me now because I am still present')
 * }
 *
 * @returns
 */
export const useIsMounted = (): (() => boolean) => {
    const isMountedRef = useRef(true);
    const isMounted = useCallback(() => isMountedRef.current, []);

    useEffect(() => {
        return (): void => void (isMountedRef.current = false);
    }, []);

    return isMounted;
};
